"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.SecondaryLightTypography = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Tab_1 = __importDefault(require("@mui/material/Tab"));
var TabContext_1 = __importDefault(require("@mui/lab/TabContext"));
var TabList_1 = __importDefault(require("@mui/lab/TabList"));
var TabPanel_1 = __importDefault(require("@mui/lab/TabPanel"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var CopyableLink = __importStar(require("./M_CopyableLink"));
var QrCode = __importStar(require("./qrCode"));
var ShareIcons = __importStar(require("./M_ShareIconsGrouped"));
exports.SecondaryLightTypography = (0, styles_1.styled)(Typography_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.secondary.light,
    });
});
/** Represents the main save/share window after successfully loading the link to share
 * Includes both URL and QR tabs
 */
var Component = function (p) {
    var _a = Hooks.useState('link'), activeTab = _a[0], setActiveTab = _a[1];
    return (Preact.h(Box_1.default, { padding: "26px", borderRadius: "8px", sx: {
            backgroundColor: 'background.default',
        } },
        Preact.h(Typography_1.default, { variant: "body1", textAlign: "center", color: "black", paddingBottom: "26px" }, p.heading),
        Preact.h(TabContext_1.default, { value: activeTab },
            Preact.h(TabList_1.default, { onChange: function (e, value) { return setActiveTab(value); }, centered: true },
                Preact.h(Tab_1.default, { label: p.urlTab, value: "link" }),
                Preact.h(Tab_1.default, { label: p.qrTab, value: "qr" })),
            Preact.h(TabPanel_1.default, { value: "link", sx: {
                    paddingX: '0px',
                    paddingY: '26px',
                } },
                Preact.h(Box_1.default, { display: "flex", alignItems: "center", justifyContent: "center" },
                    Preact.h(CopyableLink.Component, { linkToCopy: p.sharingUrl, copyToClipboard: p.copyToClipboard, helperText: p.linkHelperText, ctaText: p.linkCta }))),
            Preact.h(TabPanel_1.default, { value: "qr", sx: {
                    paddingX: '0px',
                    paddingY: '26px',
                } },
                Preact.h(Box_1.default, { display: "flex", alignItems: "center", justifyContent: "center" },
                    Preact.h(QrCode.Component, { url: p.qrUrl, size: 136 })))),
        Preact.h(exports.SecondaryLightTypography, { variant: "body2", textAlign: "center", paddingBottom: "26px" }, p.sharePrompt),
        Preact.h(ShareIcons.Component, { hrefMail: "mailto:?subject=".concat(p.mailtoSubject, "&body=").concat(p.mailtoBody, "%0A").concat(p.sharingUrl), hrefWhatsapp: 'https://api.whatsapp.com/send?text=' + p.sharingUrl, hrefFacebook: 'http://www.facebook.com/share.php?u=' + p.sharingUrl })));
};
exports.Component = Component;
